import React from 'react';

type Props = {
  show: boolean;
  categoryName: string;
  productCount?: number;
  onConfirm: () => void;
  onCancel: () => void;
};

const DeleteCategoryModal: React.FC<Props> = ({ show, categoryName, productCount, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onCancel} style={{ zIndex: 1040 }}></div>
      <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card-surface">
            <div className="modal-header border-bottom">
              <h5 className="modal-title">Delete Category</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Do you want to delete this category?</p>
              <p className="fw-bold">{categoryName}</p>
              {productCount !== undefined && productCount > 0 && (
                <div className="alert alert-warning mb-0 mt-3">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  This category has {productCount} product{productCount !== 1 ? 's' : ''}. 
                  Products will need to be reassigned to another category.
                </div>
              )}
              <p className="text-danger small mt-3">This action cannot be undone.</p>
            </div>
            <div className="modal-footer border-top">
              <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger" onClick={onConfirm}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteCategoryModal;
